interface BrandedLoaderProps {
  message?: string;
  /** Render as a fixed full-screen overlay instead of an in-flow block */
  overlay?: boolean;
}

export default function BrandedLoader({ message = 'Loading...', overlay = false }: BrandedLoaderProps) {
  const wrapperClass = overlay
    ? 'fixed inset-0 z-50 flex items-center justify-center bg-background animate-in fade-in duration-200'
    : 'min-h-screen flex items-center justify-center bg-background';

  return (
    <div className={wrapperClass}>
      <div className="flex flex-col items-center gap-6">
        <div className="relative">
          {/* Breathing pulse ring */}
          <div className="absolute inset-0 rounded-2xl border border-primary/40 animate-ping" />
          <div className="absolute inset-0 rounded-2xl border-[1.5px] border-primary/30 animate-pulse" />
          {/* N mark */}
          <div className="relative flex items-center justify-center font-serif italic w-16 h-16 rounded-2xl border-[1.5px] border-primary text-primary text-3xl bg-background">
            N
          </div>
        </div>
        <p className="text-sm text-muted-foreground tracking-wide animate-pulse">
          {message}
        </p>
      </div>
    </div>
  );
}
